<template>
  <div class="rating-bar">
    <div class="round round-1" :class="ratingClass(value)" />
    <div class="round round-2" :class="ratingClass(value)" />
    <div class="round round-3" :class="ratingClass(value)" />
    <div class="round round-4" :class="ratingClass(value)" />
    <div class="scale-rating" :class="ratingClass(value)" />
  </div>
</template>

<script>
  export default {
    name: 'SymptomBar',

    props: {
      value: {
        type: Number,
        default: 0,
      }
    },


    methods: {
      ratingClass(rating) {
        if (!rating) rating = 0;
        if (rating > 3) rating = 3;
        return `color-step-${rating}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  $color-step-0 : #76c0a1;
  $color-step-1 : #f9c262;
  $color-step-2 : #f2966e;
  $color-step-3 : #e97776;

  .rating-bar {
    margin: 0 auto;
    height: 30px;
    position: relative;
    width: 50%;
  }
  .scale-rating {
    position: absolute;
    top: 20%;
    height: 10px;
    border-radius: 2px;
    width: 100%;
    box-shadow: 0 0 2px rgba(0,0,0,0.6);

  }

  .scale-rating.color-step-0 {
    background: white
  }

  .scale-rating.color-step-1 {
    background: linear-gradient(
      to right, 
      $color-step-0 33%, 
      white 0% 
    )
  }

  .scale-rating.color-step-2 {
    background: linear-gradient(
      to right, 
      $color-step-0 33%,
      $color-step-1 45%,
      $color-step-2 66%,  
      white 0% 
    )
  }

  .scale-rating.color-step-3 {
    background: linear-gradient(
      to right, 
      $color-step-0 25%, 
      $color-step-1 50%, 
      $color-step-2 75%, 
      $color-step-3 100%
    );
  }

  .round {
    z-index: 2;
    position:absolute;
    border-radius: 50%;
    overflow: hidden;
    width: 20px;
    height: 20px;
    background-color: white;
    border: 2px solid white;
    box-shadow: 0 0 2px rgba(0,0,0,0.6);
  }

  .round-1 {
    background-color: $color-step-0;
  }

  .round-2 {
    left: 33%;

    &.color-step-0,  {
      background-color: white;
    }

    &.color-step-1, &.color-step-2, &.color-step-3,{
      background-color: $color-step-1;
    }
    
  }

  .round-3 {
    left: 66%;
    &.color-step-0, &.color-step-1 {
      background-color: white;
    }

    &.color-step-2, &.color-step-3,{
      background-color: $color-step-2;
    }
  }

  .round-4 {
    left: 100%;
    &.color-step-0, &.color-step-1, &.color-step-2 {
      background-color: white;
    }

    &.color-step-3 {
      background-color: $color-step-3;
    }
  }

</style>
